var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      attrs: { title: _vm.$t("DELETE_ASSET_MODAL_TITLE") },
      on: { hide: _vm.closeModal },
      model: {
        value: _vm.open,
        callback: function($$v) {
          _vm.open = $$v
        },
        expression: "open"
      }
    },
    [
      _vm.getReferencesStatus.status !== "pending"
        ? _c("div", [
            _vm.assetReferences && !_vm.assetReferences.hasReferences
              ? _c("p", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "DELETE_ASSET_MODAL_ASSET_NONE_ASSOCIATION_TEXT",
                      expression:
                        "'DELETE_ASSET_MODAL_ASSET_NONE_ASSOCIATION_TEXT'"
                    }
                  ]
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.assetReferences && _vm.assetReferences.hasReferences
              ? _c(
                  "div",
                  [
                    _c("i18n", {
                      attrs: {
                        path: "DELETE_ASSET_MODAL_ASSET_ASSOCIATION_TEXT",
                        tag: "p"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "assetName",
                            fn: function() {
                              return [
                                _c("strong", [_vm._v(_vm._s(_vm.assetName))])
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        3664077460
                      )
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "well well-sm m-t-10 m-b-0" }, [
                      _c("div", { staticClass: "form-horizontal" }, [
                        _vm.assetReferences.ivrtrees &&
                        _vm.assetReferences.ivrtrees.length
                          ? _c("div", { staticClass: "row" }, [
                              _c(
                                "label",
                                { staticClass: "col-md-3 control-label" },
                                [_c("strong", [_vm._v("IVR Trees")])]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-8" }, [
                                _c(
                                  "ul",
                                  {
                                    staticClass:
                                      "list-unstyled form-control-static list-text-overflow"
                                  },
                                  _vm._l(_vm.assetReferences.ivrtrees, function(
                                    ivrTree
                                  ) {
                                    return _c(
                                      "li",
                                      { key: ivrTree.ivrtreeId },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "table-ellipsis__name linked-name",
                                            attrs: {
                                              rel: "noopener",
                                              target: "_blank",
                                              href: "javascript:;"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.goToIvrTree(
                                                  ivrTree.ivrtreeId
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "display-text",
                                                attrs: {
                                                  title: ivrTree.ivrtreeName
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      ivrTree.ivrtreeName
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ])
                            ])
                          : _vm._e()
                      ])
                    ])
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.getReferencesStatus.status == "pending"
        ? _c(
            "div",
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "ASSETS_REFERENCES_LOADING",
                    expression: "'ASSETS_REFERENCES_LOADING'"
                  }
                ]
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c("button", {
          directives: [
            {
              name: "t",
              rawName: "v-t",
              value: "DELETE",
              expression: "'DELETE'"
            }
          ],
          staticClass: "btn btn-primary",
          attrs: { disabled: _vm.deleteButtonDisabled, type: "button" },
          on: {
            click: function($event) {
              return _vm.removeAsset()
            }
          }
        }),
        _vm._v(" "),
        _c("button", {
          directives: [
            {
              name: "t",
              rawName: "v-t",
              value: "CANCEL",
              expression: "'CANCEL'"
            }
          ],
          staticClass: "btn btn-danger",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.closeModal()
            }
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }